import React, { useState, useEffect } from "react";
import EditLocationForm from "./EditLocationForm";
import AddLocationForm from "./AddLocationForm";
import editIcon from "../assets/icons/EditIcon.svg";

const LocationSearch = ({ refreshTrigger }) => {
  const [locations, setLocations] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [showEditLocationForm, setShowEditLocationForm] = useState(false);
  const [showAddLocationForm, setShowAddLocationForm] = useState(false);

  const fetchLocations = () => {
    fetch('/api/locations')
      .then(r => {
        if (!r.ok) throw new Error('Failed to fetch locations');
        return r.json();
      })
      .then(data => {
        setLocations(data);
      })
      .catch(e => console.error('Error fetching locations:', e));
  };

  // Sync with refreshTrigger from parent
  useEffect(() => {
    fetchLocations();
  }, [refreshTrigger]);

  const filteredLocations = locations.filter(loc =>
    (loc.location_name?.toLowerCase() || '').includes(searchQuery.toLowerCase()) ||
    (loc.address?.toLowerCase() || '').includes(searchQuery.toLowerCase()) ||
    (loc.status?.toLowerCase() || '').includes(searchQuery.toLowerCase())
  );

  const handleAddLocation = () => setShowAddLocationForm(true);
  
  const handleEditLocation = (loc) => { 
    setSelectedLocation(loc); 
    setShowEditLocationForm(true); 
  };
  
  const handleSaveLocation = () => { 
    fetchLocations(); 
    setShowEditLocationForm(false); 
  };
  
  const handleLocationAdded = () => { 
    fetchLocations(); 
    setShowAddLocationForm(false); 
  };

  return (
    <div className="user-list-container">
      <h2>Location List</h2>

      <div className="search-container">
        <label>Search Locations:</label>
        <input
          type="text"
          placeholder="Search by name, address, or status..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
      </div>

      <div className="button-container">
        <button className="add-location-button" onClick={handleAddLocation}>
          + Add Location
        </button>
      </div>

      <div className="UserList-container">
        <table>
          <thead>
            <tr>
              <th>Location Name</th>
              <th>Address</th>
              <th>Status</th>
              {/* Centered header for the icons */}
              <th style={{ textAlign: 'center' }}>Action</th>
            </tr>
          </thead>
          <tbody>
            {filteredLocations.length > 0 ? (
              filteredLocations.map((location) => (
                <tr key={location.location_id}>
                  <td>{location.location_name}</td>
                  <td className="address">{location.address}</td>
                  <td>{location.status}</td>
                  <td className="action-cell">
                    <div className="action-wrapper">
                      <button 
                        className="icon-action-btn" 
                        onClick={() => handleEditLocation(location)}
                        title="Edit Location"
                      >
                        <img src={editIcon} alt="Edit" className="table-icon" />
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="4" style={{ textAlign: 'center', padding: '20px' }}>
                  No locations match your search.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Modals */}
      {showEditLocationForm && selectedLocation && (
        <EditLocationForm
          location={selectedLocation}
          onClose={() => setShowEditLocationForm(false)}
          onSave={handleSaveLocation}
        />
      )}

      {showAddLocationForm && (
        <AddLocationForm
          onClose={() => setShowAddLocationForm(false)}
          onLocationAdded={handleLocationAdded}
        />
      )}
    </div>
  );
};

export default LocationSearch;